import { render, staticRenderFns } from "./deleteThemeContent.vue?vue&type=template&id=5e5c84c9&lang=pug"
import script from "./deleteThemeContent.vue?vue&type=script&lang=js"
export * from "./deleteThemeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports